module.exports={render:function (){var _vm=this;
  return _vm._c('div', {
    staticClass: "about"
  }, [(this.$parent.filterTags === '') ? _vm._c('div', {
    staticClass: "arrow"
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._c('svg', {
    attrs: {
      "enable-background": "new 0 0 256 256",
      "height": "256px",
      "version": "1.1",
      "viewBox": "0 0 256 256",
      "width": "256px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('path', {
    attrs: {
      "d": "M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
    }
  })])])]) : _vm._e(), _vm._v(" "), (this.$parent.filterTags !== '') ? _vm._c('div', {
    staticClass: "arrow"
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'genre',
        params: {
          'genre': this.$parent.filterTags
        }
      }
    }
  }, [_vm._c('svg', {
    attrs: {
      "enable-background": "new 0 0 256 256",
      "height": "256px",
      "version": "1.1",
      "viewBox": "0 0 256 256",
      "width": "256px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('path', {
    attrs: {
      "d": "M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm._c('h1', [_vm._v("About")]), _vm._v("\n\n  Online cinema with public domain movies "), _vm._c('br'), _vm._v(" "), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._c('p', [_vm._v("All films displayed here are hosted on archive.org and in the Public Domain.")]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._v(" "), _vm._c('br'), _vm._c('br'), _vm._c('br'), _vm._v("\n  stats: 2237 movies"), _vm._c('br'), _vm._v("\n  last update: March 2019\n  "), _vm._c('br'), _vm._c('br'), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('b', [_vm._v("parvu@protonmail.com")])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._c('h2', [_vm._v("Film videos from "), _vm._c('a', {
    attrs: {
      "href": "https://archive.org/",
      "target": "_blank"
    }
  }, [_vm._v("Internet Archive")])])
},function (){var _vm=this;
  return _vm._c('div', [_vm._c('a', {
    attrs: {
      "href": "https://archive.org/",
      "target": "_blank"
    }
  }, [_vm._c('img', {
    attrs: {
      "width": "92",
      "height": "92",
      "src": "https://archive.org/services/img/internetarchivebooks"
    }
  })])])
},function (){var _vm=this;
  return _vm._c('h2', [_vm._v("Film datas from "), _vm._c('a', {
    attrs: {
      "href": "https://www.themoviedb.org/",
      "target": "_blank"
    }
  }, [_vm._v("TMDb")])])
},function (){var _vm=this;
  return _vm._c('div', [_vm._c('a', {
    attrs: {
      "href": "https://www.themoviedb.org/",
      "target": "_blank"
    }
  }, [_vm._c('img', {
    attrs: {
      "width": "92",
      "height": "92",
      "src": require("../assets/tmdb.svg")
    }
  })])])
},function (){var _vm=this;
  return _vm._c('p', [_vm._v("All film-related metadata used here, including director, synopses, "), _vm._c('br'), _vm._v("\n\trelease dates, poster art and backdrops is supplied by TMDb. "), _vm._c('br'), _vm._v("\n\tWe use the TMDb API but our app is not endorsed or certified by TMDb.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-250ec3d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 349
// module chunks = 2